// Styles for SearchResultsComponent go here.
import styled from 'styled-components';
import { baseVariables, contextualVariable, toRem } from '@marriott/mi-ui-library';

export const StyledSearchResultsComponent = styled.div`
  .icons-tabs-container {
    box-shadow: none !important;
    padding: 0 !important;
  }

  .m-icon-tab-list .m-icon-tab-list-item {
    a span.t-font-xs {
      display: none;
    }
    @media ${baseVariables.mediaQuery['lg']} {
      a span.t-font-xs {
        display: inline;
      }
    }
    padding-left: ${toRem(16)};
    padding-right: ${toRem(16)};
    margin: ${toRem(4)};
    border-radius: ${toRem(16)} !important;
    width: fit-content;
    flex: unset;
  }

  .m-icon-tab-list {
    border-radius: ${toRem(20)} !important;
  }

  .m-icon-tab-list-item.active {
    border-bottom: unset !important;
  }

  .icons-tabs-container {
    max-width: unset;
    width: unset;
    margin: unset;
  }

  .m-icon-tab-wrapper {
    padding: unset !important;
  }

  .m-switcher-tab-list {
    margin: unset !important;
  }

  .filter-pill {
    flex-direction: row-reverse !important;

    .pill-icon {
      margin-left: ${toRem(4)} !important;
      margin-right: 0 !important;
    }
  }

  .pill {
    border-radius: ${contextualVariable?.buttonSizes?.m?.['borderRadius']} !important;
  }

  .m-button-primary-inverse:hover,
  .m-button-primary-inverse.is-hover {
    box-shadow: none !important;
    background-color: ${baseVariables.color.neutral10};
  }

  .ACTIVITIES .brand-logo-container {
    aspect-ratio: 151/58;
    @media only ${baseVariables.mediaQuery.md} {
      & {
        aspect-ratio: 76 / 29;
      }
    }

    @media only ${baseVariables.mediaQuery.lg} {
      & {
        aspect-ratio: auto;
      }
    }
  }

  .m-icon-text-block span.text-container {
    display: flex;
    flex-direction: row !important;
    gap: ${toRem(8)};
  }
`;
